export default __webpack_public_path__ + "static/media/404error.ef269a10.gif";